import axios from "axios";
import { getStoreValue, updateStore } from "../utils/store";

let refreshPromise: Promise<any> | null = null;
const clearPromise = () => (refreshPromise = null);

const refreshToken = async () => {
  const response = await axios.post(
    process.env.REACT_APP_API_BASEURL + "/auth/refresh",
    {
      refreshToken:
        getStoreValue("refreshToken") &&
        window.atob(getStoreValue("refreshToken")),
    }
  );
  response?.data?.accessToken &&
    updateStore("token", window.btoa(response?.data?.accessToken));
  response?.data?.refreshToken &&
    updateStore("refreshToken", window.btoa(response?.data?.refreshToken));
  return response?.data?.accessToken;
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL,
});

instance.interceptors.request.use(function (config) {
  const token = getStoreValue("token");
  const decodedToken = token && window.atob(token);
  config.headers.Authorization = decodedToken
    ? `Bearer ${decodedToken}`
    : "No Token";
  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (err) => {
    const originalConfig = err.config;
    if (originalConfig.url !== "auth/token" && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        if (!refreshPromise) {
          refreshPromise = refreshToken()
            .catch((err) => {
              if (err?.response?.status === 401) {
                window.location.href =
                  getStoreValue("isAdmin") &&
                  JSON.parse(getStoreValue("isAdmin"))
                    ? `${process.env.REACT_APP_SUBDIRECTORY}/users/login`
                    : originalConfig.url.includes("/report/user-apps")
                    ? `${process.env.REACT_APP_SUBDIRECTORY}/users/login`
                    : `${process.env.REACT_APP_SUBDIRECTORY}`;
              }
            })
            .finally(clearPromise);
        }

        const token = await refreshPromise;
        originalConfig.headers.Authorization = `Bearer ${token}`;

        return instance(originalConfig);
      }
    }

    return Promise.reject(err);
  }
);

export default instance;
